import { Typography } from "antd";
import React from "react";

interface PageDeleteProps {
  deleteName: any;
}

const PageDelete: React.FC<PageDeleteProps> = ({ deleteName }) => {
  const { Text } = Typography;

  return (
    <div>
      <Text>
        Do you want to delete the page{" "}
        <span style={{ fontWeight: "bold" }}>{deleteName.name}</span>?
      </Text>
    </div>
  );
};

export default PageDelete;
